import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import userTableModel from '../../models/table.model';
import categoryType from '../../models/categoryType.model';
import { CategoryType } from '../../models/type.model';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import environment from '../../environment';
import Swal from 'sweetalert2';
import Layout from '../../components/global/layout';
import SelectDropdown from '../../components/common/SelectDropdown';
import { HiArrowSmUp } from "react-icons/hi";

import Pagination from 'react-pagination-js';
import { Tooltip } from 'antd';
import { HiOutlineArrowDown } from 'react-icons/hi';
import moment from 'moment';
import methodModel from '../../methods/methods';
import { MdOutlineDone } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { toast } from 'react-toastify';
import { Dialog } from '@headlessui/react';
import { IoMdDownload } from "react-icons/io";

const certificateRequestlist = () => {
  let user = useSelector((state) => state.user);
  const history = useNavigate();
  const dragItems = useRef();
  const searchState = useSelector((state) => state.search);
  const [filters, setFilter] = useState({
    page: 1,
    count: 10,
    search: '',
    role: '',
    key: '',
  });
  const [data, setData] = useState([]);
  const [getrole, setrole] = useState([]);
  let param = new URLSearchParams(window.location.search);
  const dashboardfilter = param.get("filter");

  const [item, setitem] = useState('');
  const [tab, setTab] = useState('list');
  const [total, setTotal] = useState(0);
  const [loaging, setLoader] = useState(true);
  const [RequestStatus, setRequestStatus] = useState('');
  const statusOptions = [{ id: 'accepted', name: 'Accepted' }, { id: 'rejected', name: 'Rejected' },
  { id: 'pending', name: 'Pending' },]

  const [Open, setOpen] = useState(false);
  const [reason, setreason] = useState('');

  const close = () => setOpen(false)

  const OpenModal = (e, itm, status) => {
    setOpen(e)
    setitem(itm)


    setRequestStatus(status)
  }

  useEffect(() => {

    getRoles();
  }, []);

  // useEffect(() => {
  //   if (user && user.loggedIn) {
  //     setFilter({ ...filters, search: searchState.data });
  //     getData({ search: searchState.data, page: 1 });
  //   }
  // }, [searchState]);
  useEffect(() => {
    if (dashboardfilter) {
      setFilter({ ...filters, status: dashboardfilter })
      getData({ status: dashboardfilter })
    } else {
      setFilter({ ...filters, search: searchState.data });
      getData({ search: searchState.data, page: 1 });
    }
  }, [dashboardfilter])

  const getData = (p = {}) => {
    setLoader(true);
    let filter = { ...filters, ...p, isDeleted: false };
    ApiClient.get('all/request', filter).then((res) => {
      if (res.success) {
        setData(res?.data);
        setTotal(res?.total);
        showData();
      }
      setLoader(false);
    });
  };

  const getRoles = () => {
    // loader(true)

    ApiClient.get('role/all', { status: 'active' }).then((res) => {
      loader(true)
      if (res.success) {
        loader(true)
        let data = res.data;
        data = data.filter((itm) => itm.id != environment.userRoleId);

        let ExtractRoles = res?.data?.filter(
          (itm) => itm?.role === 'leagues' || itm?.role === 'coaches'
        );

        let filterData = ExtractRoles?.map((itm) => {
          return { id: itm?.role, name: itm?.role };
        });
        setrole(filterData);
      }
      loader(false)

    });
    // loader(true)
  };

  const clear = () => {
    setFilter({ ...filters, search: '', page: 1 });
    getData({ search: '', page: 1 });
  };

  const filter = (p = {}) => {
    setFilter({ ...filters, page: 1, ...p });
    getData({ page: 1, ...p });
  };

  const reset = () => {
    let p = {
      status: '',
      role: ''
    };
    setFilter({ ...filters, page: 1, ...p });
    getData({ page: 1, ...p });
    if (dashboardfilter) {
      history("/certificate-requests")
    } else {

    }
  };


  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };

  const ChangeStatus = (e) => {
    setFilter({ ...filters, status: e, page: 1 });
    getData({ status: e, page: 1 });
  };


  const statusChange = () => {
    let status = RequestStatus == 'accept' ? 'accepted' : 'rejected';
    let payload = {
      id: item.id, status: status
    }
    if (RequestStatus == 'reject') {
      payload = { ...payload, reason: reason }
    }
    ApiClient.put(`request/status`, payload).then(
      (res) => {
        if (res.success) {
          toast.success('Status updated successfully')
          setOpen(false)
          setRequestStatus('')
          setitem('')
          setreason('')
          getData();
        }
      }
    );
  };

  const view = (id) => {
    history('/request/' + id);
  };


  const handleItemCountChange = (e) => {
    setFilter({ ...filters, page: 1, count: e?.target?.value });
    getData({ page: 1, count: e?.target?.value });
  };

  const exportBlob = async (itm) => {
    const token = await localStorage.getItem('CRA_auth_token');
    const req = await axios({
      method: 'get',
      url: `${environment?.api}download/pdf?id=${itm?.id}`,
      responseType: 'blob',
      body: { token: token },
    });
    var blob = new Blob([req.data], {
      type: req.headers['content-type'],
    });
    const link = document.createElement('a'); //a for anchor tag
    link.href = window.URL.createObjectURL(blob);
    link.download = `certificate.pdf`;
    link.click();
  };

  const showData = () => {
    let value = data;
    if (dragItems && dragItems.current) value = dragItems.current;
    return value;
  };

  const isAllow = (key = '') => {
    let permissions = user.roleDetail?.permissions;
    let value = permissions?.[key];
    if (user?.roleDetail?._id == environment.adminRoleId) value = true;
    return value;
  };

  const sortClass = (key) => {
    let cls = 'fa-sort';
    if (filters.key == key && filters.sorder == 'asc') cls = 'fa-sort-up';
    else if (filters.key == key && filters.sorder == 'desc')
      cls = 'fa-sort-down';
    return 'fa ' + cls;
  };

  const sorting = (key) => {
    let sorder = 'asc';
    if (filters.key == key) {
      if (filters.sorder == 'asc') {
        sorder = 'desc';
      } else {
        sorder = 'asc';
      }
    }

    let sortBy = `${key} ${sorder}`;
    setFilter({ ...filters, sortBy, key, sorder });
    getData({ sortBy, key, sorder });
  };

  const renderSortIcon = (columnKey) => {
    if (filters.key !== columnKey)
      return <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
    else {
      if (filters.sorder === 'asc') {
        <HiArrowSmUp className="shrink-0 inline text-sm" />;
      } else {
        <HiOutlineArrowDown className="shrink-0 inline text-sm" />;
      }
    }
    return filters.sorder === 'asc' ? (
      <HiArrowSmUp className="shrink-0 inline text-sm" />
    ) : (
      <HiOutlineArrowDown className="shrink-0 inline text-sm" />
    );
  };

  const exportCertificate = (itm) => {
    console.log(itm)
    if (itm?.path) {
      let url = res.path;
      let downloadAnchor = document.getElementById('downloadJS');
      downloadAnchor.href = url;
      downloadAnchor.click();
    }

  }

  const ChangeroleFilter = (key) => {
    setFilter({ ...filters, role: key, page: 1 });
    getData({ ...filters, role: key });
  };

  return (
    <Layout>
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-2xl font-semibold text-[#111827]">Certificate Requests</h3>
          <p class="text-sm font-normal text-[#525252]">
            Here you can see all about Certificate Request
          </p>
        </div>

        <div className="flex gap-2">

          <div className="flex justify-end items-center gap-2">
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Roles"
              intialValue={filters?.role}
              result={(e) => {
                ChangeroleFilter(e.value);
              }}
              options={getrole}
            />


            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="All Status"
              intialValue={filters.status}
              result={(e) => {
                ChangeStatus(e.value);
              }}
              options={statusOptions}
            />
            {filters.status || filters.role ? (
              <>
                <button
                  className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2"
                  onClick={reset}
                >
                  Reset
                </button>
              </>
            ) : (
              <></>
            )}
          </div>

        </div>
      </div>

      <div className="shadow-lg w-full bg-white rounded-lg mt-6">
        {tab == 'grid' ? (
          <></>
        ) : (
          <>
            <div className="w-full bg-white rounded-lg">
              <div className="scrollbar w-full overflow-auto">
                <table class="w-full">
                  <thead className="text-xs text-gray-700 capitalize bg-gray-50  border-b border-[#EAECF0]">
                    <tr className="border-b border-[#EAECF0]">
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                        onClick={(e) => sorting('fullname')}
                      >
                        User Name{' '}
                        <span className="ml-2">{renderSortIcon('fullname')}</span>
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                        onClick={(e) => sorting('createdAt')}
                      >
                        Requested At{' '}
                        <span className="ml-2">
                          {renderSortIcon('createdAt')}
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                      >
                        Course
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                      >
                        Assessment
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                      >
                        Score
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="px-5 py-3 capitalize cursor-pointer text-left whitespace-nowrap  "
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="planDrag">
                    {!loaging &&
                      data &&
                      showData().map((itm, index) => {
                        return (
                          <tr
                          >
                            <td
                              className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 text-left border-[#EAECF0]"
                            >
                                <Tooltip placement="right" title="View">
                              <h4 className='user cursor-pointer' onClick={(e) => view(itm.id)}>
                              {methodModel?.capitalizeFirstLetter(itm.fullName)}
                              </h4>
                              </Tooltip>
                            </td>
                            <td
                              className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]"
                            >
                              {moment(itm.createdAt).format('DD MMM YYYY')}
                            </td>

                            <td
                              className="capitalize !text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]"
                            >
                              {itm?.title}
                            </td>

                            <td
                              className="capitalize !text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]"
                            >
                              {itm?.assessment_name}
                            </td>
                            <td
                              className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]"
                            >
                              {itm?.total_marks}/{itm?.weightage}
                            </td>
                            <td className="!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]">
                              <div
                                className={`user_hours ${itm.status}`}
                              >
                                <span
                                  className={`capitalize bg-[#1c2b35] text-white text-sm w-[100px] cursor-pointer !px-3 h-[30px] flex items-center justify-center border !rounded ${itm.status === 'pending'
                                    ? 'bg-[#aa7e10]' : itm.status === 'accepted' ? 'bg-[#bg-[#A12238]]'
                                      : 'bg-[#A12238] '
                                    }`}
                                >
                                  {itm.status}
                                </span>
                              </div>
                            </td>
                            <td className='!text-typo !border-l-0 !px-5 text-sm font-normal !py-2 !border-r-0 border-[#EAECF0]'>
                              <div className='flex items-center gap-1.5 '>

                                {itm.status == 'pending' ? <div className='border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#046e04] flex items-center justify-center text-md' onClick={() => OpenModal(true, itm, 'accept')}>
                                  <MdOutlineDone className='' />
                                </div> : ''}
                                {itm.status == 'pending' ? <div className='border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#E92531] flex items-center justify-center text-md' onClick={() => OpenModal(true, itm, 'reject')} >
                                  <IoMdClose className='' />
                                </div> : ''}
                                {itm.status == 'accepted' ? <div className='border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#A42238] flex items-center justify-center text-md' onClick={() => exportBlob(itm)} >
                                  <IoMdDownload className='' />
                                </div> : ''}

                                {itm.status == 'rejected' ? <div className='border cursor-not-allowed !border-[#E9253129] hover:opacity-70 rounded-md bg-[#fff] w-8 h-8 text-[#A42238] flex items-center justify-center text-md'>
                                  <IoMdDownload className='' />
                                </div> : ''}


                              </div>
                            </td>


                            {/* end */}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
        {!loaging && total == 0 ? (
          <div className="py-3 text-center text-[#8b8b8b]">No Data</div>
        ) : (
          <></>
        )}
        {!loaging && total > 10 ? (
          <div className="paginationWrapper  mt-15">
            <span className='text-sm text-gray-600'>Show {filters.count} from {total} Certificate Requests
            </span>

            <select
              className="border-[1px] border-[#cfd5dc] rounded-[5px] px-[5px] py-[5px] bg-white text-[12px] mr-3"
              value={filters.count} // Current value of items per page
              onChange={(e) => handleItemCountChange(e)} // Function to handle changes
            >
              {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>

            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />

          </div>
        ) : (
          <></>
        )}
        {loaging ? (
          <div className="text-center py-4">
            <img src="/assets/img/loader.gif" className="pageLoader" />
          </div>
        ) : (
          <></>
        )}
      </div>

      <Dialog open={Open} onClose={() => setOpen(false)}>
        <Dialog.Backdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-[#00000082]">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Dialog.Panel
              className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-[800px] data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="bg-white px-4 pb-4 pt-3 ">
                <div className="">

                  <div className="mt-3 text-center sm:mt-0 sm:text-left">
                    <h3 className="text-base font-semibold leading-6 text-gray-900 pb-2 mb-3 border-b-[1px]">
                      Preview
                    </h3>
                    <div>
                      <div className='section_certificate flex justify-center items-center bg-[#f8f9fc] '>
                        <div className='w-[750px] h-fit bg-white py-[0.5rem] relative'>
                          <div className='section_certificate flex justify-center items-center'>
                            <div className='w-[420px]'>
                              <div className='flex justify-center'>
                                <img src="/assets/img/logo.png" className='w-[70px] h-[70px] mb-2'></img>
                              </div>
                              <h3 className='text-center text-[32px] leading-[30px]'>CERTIFICATE</h3>
                              <p className='text-center text-[12px]'>for the successful completion of  {item?.assessment_name} assessment</p>
                              <div className='h-[2px] bg-[#A12238] w-[50px] mx-auto mt-3 mb-3'></div>
                              <h2 className='text-center font-[600] text-[14px]'> THIS CERTIFICATE IS PROUDLY PRESENTED TO </h2>
                              <h4 className='client_name text-center text-[32px] text-[#646464] mt-3 mb-3 capitalize'>{item?.fullName}</h4>
                              <div className='flex justify-between items-center mb-5'>
                                <div className='text-[10px] bg-[#A12238] text-white font-[500] flex justify-center items-center h-[20px] px-2 whitespace-nowrap min-w-[150px] leading-[14px]'>Marks Obtained:<span>{item?.total_marks + '/' + item?.weightage}</span></div>
                                <div className='h-[2px] bg-[#A12238] w-full'></div>
                                <div className='text-[10px] bg-[#A12238] text-white font-[500] flex justify-center items-center h-[20px] px-2 whitespace-nowrap min-w-[150px] leading-[14px] capitalize'>Status:<span>{item?.result}</span></div>
                              </div>
                              <div className='flex justify-between items-center gap-3 mb-5'>
                                <div className='text-center'>
                                  <h3 className='text-[12px] font-[500]'>{moment(new Date).format('DD-MM-YYYY')}</h3>
                                  <div className='h-[1px] bg-[#000] w-[130px] mb-[2px] mt-[2px]'></div>
                                  <p className='text-[12px] text-[#121212]'>DATE</p>
                                </div>
                                <img src="/assets/img/tag.png" className='h-[90px] object-contain'></img>
                                <div className='text-center'>
                                  <h3 className='text-[12px] font-[500]'>Admin</h3>
                                  <div className='h-[1px] bg-[#000] w-[130px] mb-[2px] mt-[2px]'></div>
                                  <p className='text-[12px] text-[#121212]'>SIGNATURE</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <img src="/assets/img/left_img.png" className='absolute left-0 top-0 w-[105px]'></img>
                          <img src="/assets/img/right_img.png" className='absolute right-0 top-0 w-[105px]'></img>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p className='text-[12px] text-center mb-2 text-[#121212] px-4'>Do you want to {RequestStatus} this request</p>
              <div className='px-5 mb-3'>
                {RequestStatus == 'reject' ? <> <label className=''>
                  Give Reason<span className="star">*</span>
                </label><input placeholder='Please give reason' type='text' className=' relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2' value={reason} onChange={e => setreason(e.target.value)} /> </> : <></>}
              </div>
              <div className='border-t-[1px]'>
                <div className="px-4 py-3 flex justify-between sm:px-6 max-w-[400px] mx-auto">
                  <button
                    type="button"
                    data-autofocus
                    onClick={() => setOpen(false)}
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-[#efefef] px-8 py-2 text-sm font-semibold text-[#353535] shadow-sm !ring-0 border-[1px] !outline-0 hover:opacity-[80%] sm:mt-0 sm:w-auto"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    data-autofocus
                    onClick={() => statusChange()}
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-[#A12238] px-8 py-2 text-sm font-semibold text-white shadow-sm !ring-0 !border-0 !outline-0 hover:opacity-[80%] sm:mt-0 sm:w-auto"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>


    </Layout>
  )
}

export default certificateRequestlist